import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M12 5.333a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z"
        fill={props.color ?? "#141416"}
        fillOpacity={0.9}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.962.834h.076c1.539 0 2.745 0 3.686.126.963.13 1.723.4 2.32.996.596.597.866 1.357.996 2.32.126.941.126 2.147.126 3.686v.059c0 1.273 0 2.314-.069 3.162-.07.853-.211 1.565-.53 2.157-.14.26-.314.495-.523.704-.597.597-1.357.867-2.32.996-.941.127-2.147.127-3.686.127h-.076c-1.54 0-2.746 0-3.687-.127-.963-.129-1.723-.4-2.32-.996-.528-.528-.801-1.186-.946-2.004-.143-.802-.17-1.8-.175-3.038L.833 8v-.038c0-1.54 0-2.746.127-3.687.129-.963.4-1.723.996-2.32.596-.596 1.356-.866 2.32-.995.94-.127 2.146-.127 3.686-.127M4.408 1.95c-.852.115-1.366.334-1.745.713-.38.38-.598.893-.713 1.746-.116.867-.117 2.005-.117 3.59v.563l.667-.584a1.533 1.533 0 012.094.07l2.86 2.86a1.333 1.333 0 001.71.148l.198-.14a2 2 0 012.488.15l1.887 1.698c.19-.399.303-.923.363-1.662.066-.804.066-1.805.066-3.102 0-1.586-.001-2.724-.117-3.591-.115-.853-.333-1.367-.713-1.747-.38-.379-.893-.597-1.746-.712-.866-.116-2.005-.117-3.59-.117-1.586 0-2.725.001-3.592.117z"
        fill={props.color ?? "#141416"}
        fillOpacity={0.9}
      />
    </svg>
  );
}

export default SvgComponent;
